<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-card-list
          title="Daftar Grup Kelas"
          :add="isCan('kelas')"
          search
          id-key
          filter
          @refresh="load"
          :items="items"
          footerLabel="Grup"
          @search="
            search => {
              textSearch = search;
              pencarian();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <v-container>
              <v-row class="mx-3">
                <v-col cols="3" sm="1" md="1" lg="1" align="center">
                  <v-avatar width="50" height="50" :size="45" color="secondary2">
                    <v-icon color="secondary">mdi-google-classroom</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="10">
                  <v-row>
                    <v-col class="py-0" cols="12" md="4" sm="4">
                      <p class="caption my-0 py-0 grey--text align-left">Nama</p>
                      <router-link
                        class="primary--text ok title"
                        :to="{
                          name: 'grup.detail',
                          params: { instansi_id: item.instansi_id, diklat_id: item.diklat_id, grup_id: item.id }
                        }"
                        >{{ pVal(item, "nama") }}</router-link
                      >
                    </v-col>
                  </v-row>
                </v-col>

                <v-col lg="1" md="1" sm="1" cols="1">
                  <m-menu right class="clearfix" style="float:right" :items="more_menu" :object="item" />
                </v-col>
              </v-row>
            </v-container>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../grup/components/Form.vue";

export default {
  components: {
    ChangeDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detail",
          icon: "mdi-eye",
          color: "info",
          click: (i, o) =>
            this.$router.push({
              name: "grup.detail",
              params: {
                instansi_id: o.instansi_id,
                diklat_id: o.diklat_id,
                kelas_id: o.id
              }
            })
        },
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o),
          check: () => isCan("kelas")
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o),
          check: () => isCan("kelas")
        }
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("grup/get", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            peran: this.peran
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    course(val) {
      window.open(val.link_moodle, "_blank");
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    approve(item) {
      this.$confirm(
        `Apakah Anda yakin akan mengesahkan grup ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
        <span>Anda tidak dapat mengubah mata pelajaran yang telah Anda pilih setelah data Anda sahkan</span>`
      )
        .then(() => this.$store.dispatch("grup/syncModul", item))
        .then(() => {
          this.$info("Grup  " + item.nama + " berhasil disinkron");
        })
        .then(() => this.load())
        .catch(e => e);
    },

    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus grup ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("grup/drop", item))
        .then(() => {
          this.$info("Grup " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {
    diklat_id() {
      this.load();
    }
  }
};
</script>
